import { Layout } from '@/views/sector';

export default {
    path: '/sector',
    component: Layout,
    children: [
        { path: 'summary', component: () => import('@/views/sector/Summary.vue') },
        { path: 'add', component: () => import('@/views/sector/AddSector.vue') },
    ]
};
